import {
  BreakPointCondition,
  Heading,
  Icon,
  IconButton,
  Text,
  useBreakpointIf,
  HStack,
  VStack,
} from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Button, Pressable } from 'native-base';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

interface ResumeHeaderProps {
  isTablet: boolean;
  handleExportNewOrder: () => void;
  selectContainer: { w: string };
}

export const ResumeHeader: React.FC<ResumeHeaderProps> = ({ handleExportNewOrder }) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');

  const MobileTitleComponent = (
    <Text color={'neutral.black'} variant={'semibold'} fontSize={Typography['fontsize.lg']}>
      Boleta enviada
    </Text>
  );
  const DefaultTitleComponent = (
    <HStack alignItems={'center'} space={Spacing['inline.xxxs']}>
      <IconButton
        icon="ArrowLeft"
        testId="return-button"
        shadow={3}
        variant={'link'}
        onPress={() => navigate('Cockpit')}
        iconColor={Color['brand.tertiary.principal']}
        iconSize="xs"
      />
      <Heading testId="qa" size="h2">
        Boleta enviada
      </Heading>
    </HStack>
  );
  const Title = isMobile ? MobileTitleComponent : DefaultTitleComponent;

  return (
    <VStack
      space={Spacing['stack.xxxs']}
      pt={Spacing['inset.md']}
      paddingBottom={{
        base: 0,
        sm: Spacing['stack.xxs'],
      }}>
      {isMobile && (
        <HStack alignItems={'center'} space={Spacing['inline.xxxs']}>
          <Pressable onPress={() => navigate('Cockpit')}>
            <Icon
              name="ArrowLeft"
              testID="return-button"
              color={Color['brand.primary.principal']}
              size="xxs"
            />
          </Pressable>
          <Text testId="qa" variant="semibold" fontSize={Typography['fontsize.lg']}>
            Cockpit
          </Text>
        </HStack>
      )}
      <HStack alignItems={'center'} justifyContent={'space-between'}>
        {Title}
        <HStack space={Spacing['inset.xxxs']}>
          <Button
            variant="textLink"
            onPress={handleExportNewOrder}
            leftIcon={
              <Icon testID="qa" name="Pdf" size="xxxs" color={Color['brand.tertiary.principal']} />
            }>
            EXPORTAR EM PDF
          </Button>
        </HStack>
      </HStack>
    </VStack>
  );
};
